import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { FaExclamationCircle } from 'react-icons/fa';
import { Collapse, notification } from 'antd';
import { useDispatch } from 'react-redux';
import { t } from '../../i18n/i18n';
import useCreateTestGroup from '../../hooks/useCreateTestGroup';
import BackgroundTop from '../../components/BackgroundTop/BackgroundTop';
import { TestGroupSetting } from '../../components/TestGroupCreator/TestGroupSettings/TestGroupSetting';
import { TestGroupAssignment } from '../../components/TestGroupCreator/TestGroupAssignment/TestGroupAssignment';
import { TestGroupLanguage } from '../../components/TestGroupCreator/TestGroupLanguages/TestGroupLanguages';
import useCreateScreening from '../../hooks/useCreateScreening';
// import { TestGroupDifficultyConfig } from '../../components/TestGroupCreator/TestGroupDifficultyConfig/TestGroupDifficultyConfig';
import { TestGroupAdvancedSettings } from '../../components/TestGroupCreator/TestGroupAdvancedSettings';
import TestGroupsItem from '../../components/TestGroupsItem/TestGroupsItem';
import HorizontalLoader from '../../components/HorizontalLoader/HorizontalLoader';
import Spinner from '../../components/spinner/Spinner';
import { useTranslateTestgroup } from '../../hooks/useTranslateTestgroup';
import CountryFlag from '../../components/CountryFlag/CountryFlag';
import { CREATE_ABM_TESTGROUP_SCREENING } from '../../constants/routes';
import Modal from '../../components/Modal/Modal';
import TranslationModalTabs from '../../components/TranslationModalTabs/TranslationModalTabs';
import DebouncedButton from '../../components/Button/Button';
import {
  setTestgroupToTranslate,
  setTranslateTest,
} from '../../redux/actions/testGroupCreatorActions';

const { Panel } = Collapse;
const TranslateTestGroup = () => {
  const history = useHistory();
  const [activeKey, setActiveKey] = useState([]);
  const [showTestModal, setShowTestModal] = useState(false);
  const dispatch = useDispatch();
  const [savingTestGroupTranslation, setSavingTestGroupTranslation] = useState(false);
  const { id } = useParams();
  const navigate = useHistory();
  const {
    handleModifyData,
    handleSelectCategoryOption,
    handleSelectLevelOption,
    handleSelectMinimumTierOption,
    setChallengeAlkemy,
    handleFilterChange,
    testGroupData,
    challengeAlkemy,
    technologies,
    setTechnologies,
    isLoading,
    isEdit,
    testGroupRolesFilterOptions,
    testGroupTagsFilterOptions,
    endorsementCreatorsOptions,
    endorsementCompaniesOptions,
    testgroupWithThemes,
    setTestgroupWithThemes,
    handleSelectTagsOptions,
    handleSelectEndorsementOptions,
    handleSelectCompanyUsageOptions,
    handleSelectRolesOptionsMultiple,
    techChallengeAlkemy,
    handleHideTitle,
    handleIsAutomaticContinue,
    handleWithoutTime,
    groupSliderInitialData,
    toggleScoreTags,
    testFormats,
    step,
    handleSetAssignment,
    testGroupQuantityQuestions,
    testGroupDifficult,
    testDifficulty,
    availableThemes,
    testGroupTheme,
    testGroupListeningTest,
    disabledCreateSet,
    testGroupQuestions,
    setShow,
    setItemDelete,
    customTestgroupInitialData,
    handleAdvancedSetting: handleAdvancedSettingOriginal,
    availableSubskills,
    handleSelectSubskills,
    testGroupSubskills,
  } = useCreateTestGroup(id);

  const {
    testgroupTranslated,
    testGroupLanguageList,
    translatedTests,
    originalLanguage,
    originalIsoCode,
    languageToTranslate,
    isoCodeToTranslate,
    disableTestgroupTranslation,
    handleUpdateTranslatedTestgroup,
    setAlreadyTranslatedTests,
    saveTestgroupTranslated,
  } = useTranslateTestgroup();

  const handleAdvancedSetting = (newAdvancedSetting) => {
    // Update the translated testgroup
    handleUpdateTranslatedTestgroup('advancedSetting', newAdvancedSetting);
    // Also update the original testgroup data
    handleAdvancedSettingOriginal(newAdvancedSetting);
  };

  const {
    newScreening,
    testGroupLevelsFilterOptions,
    testGroupCategoriesFilterOptions,
    setEditData,
  } = useCreateScreening();

  const [assignmentLanguage, setAssignmentLanguage] = useState(
    step.subtitle[originalLanguage] ? originalLanguage : languageToTranslate
  );
  const [selectedDetailsLang, setSelectedDetailsLang] = useState(
    languageToTranslate || testGroupData?.languages?.[0] || 'es'
  );

  const emptyHandler = () => {};

  useEffect(() => {
    if (!originalLanguage || !originalIsoCode || !languageToTranslate || !isoCodeToTranslate) {
      navigate.push(CREATE_ABM_TESTGROUP_SCREENING);
    }
  }, []);

  useEffect(() => {
    if (newScreening.customTestGroup?.length > 0) {
      const tests = newScreening.customTestGroup;
      setAlreadyTranslatedTests(tests);
      if (!testgroupTranslated?.tests || testgroupTranslated?.tests?.length < 1) {
        handleUpdateTranslatedTestgroup('tests', tests);
      }
    }
  }, [newScreening.customTestGroup]);

  const handleCollapseChange = (key) => {
    setActiveKey(key);
  };

  useEffect(() => {
    if (testGroupData) {
      dispatch(setTestgroupToTranslate(testGroupData));
    }
  }, [testGroupData]);

  const handleSelectTest = (test) => {
    setEditData(test);
    let testToSelect;
    if (translatedTests[test.id]) {
      testToSelect = { ...test, ...translatedTests[test.id] };
    } else {
      testToSelect = test;
    }
    dispatch(setTranslateTest(testToSelect));
    setShowTestModal(true);
  };

  const configMissingTests = testGroupQuestions?.some((c) => {
    const count = Object.values(translatedTests)?.filter(
      (test) => test?.difficultyId === c.difficultyId
    )?.length;
    if (count < c.quantity) {
      return true;
    }
    return false;
  });

  const hasAssignment =
    (step?.subtitle?.[originalLanguage] || step?.subtitle?.[originalLanguage]?.trim()) !== '' &&
    (!step.subtitle?.[languageToTranslate] || step?.subtitle?.[languageToTranslate]?.trim() === '');

  const handleSaveTestgroupTranslated = async () => {
    try {
      setSavingTestGroupTranslation(true);
      await saveTestgroupTranslated(id, step);
      notification.open({
        message: t('TESTGROUP_TRANSLATION_SAVED_SUCCESSFULL'),
        type: 'success',
      });
    } catch (e) {
      if (e.code === 400) {
        notification.open({
          message: t('TESTGROUP_TRANSLATION_SAVED_ERROR') + e.message,
          type: 'error',
        });
      } else {
        console.error(e);
        notification.open({
          message: t('TESTGROUP_TRANSLATION_SAVED_ERROR'),
          type: 'error',
        });
      }
    } finally {
      setSavingTestGroupTranslation(false);
    }
  };

  return (
    <div className="w-100 mx-auto h-100">
      {isLoading ? (
        <Spinner show />
      ) : (
        <>
          <BackgroundTop
            title={t('TRANSLATE_TESTS')}
            showBase
            className="position-relative"
            titleClassname="text-title"
            routes={[
              { text: 'ABM_PAGE_TITLE', clickable: true, route: CREATE_ABM_TESTGROUP_SCREENING },
              ...(history.location.state?.from
                ? [
                    {
                      text: history.location.state?.fromName,
                      clickable: true,
                      route: history.location.state?.from,
                    },
                  ]
                : []),
            ]}
          />
          <div className="description-container create-screening-container w-100 bg-white position-relative mx-auto p-4 rounded ">
            <div className="d-flex justify-content-start w-100">
              <div className="column-flex">
                <div className="row">
                  <span className="font-weight-bold text-base my-1">
                    <CountryFlag countryIso={originalIsoCode} size="sm" className="mr-2" />
                    {t('CREATE_TEST_GROUP_NAME_TITLE')}: {testGroupData?.name}
                  </span>
                </div>
              </div>
            </div>
            <Modal
              show={showTestModal}
              className="w-100 z-3"
              closeBtnClassname="text-blue-principal font-weight-bold"
              setShow={setShowTestModal}
              showCloseButton
            >
              {showTestModal && (
                <>
                  <TranslationModalTabs
                    languageTestToShow={languageToTranslate}
                    testgroupWithThemes={testgroupWithThemes}
                    onSaveSuccess={() => setShowTestModal(false)}
                  />
                </>
              )}
            </Modal>
            <Collapse
              expandIconPosition="end"
              bordered={false}
              className="px-4 py-1 w-100 align-items-center justify-content-between mb-2 bg-white"
              activeKey={activeKey}
              onChange={handleCollapseChange}
            >
              <Panel
                header={t('CREATE_TESTGROUP_TITLE_COLLAPSE_SETTINGS')}
                key="1"
                className="panel-container bg-gray border-none "
              >
                <TestGroupSetting
                  testGroupData={testGroupData}
                  newScreening={newScreening}
                  handleSelectMinimumTierOption={handleSelectMinimumTierOption}
                  handleSelectLevelOption={handleSelectLevelOption}
                  testGroupLevelsFilterOptions={testGroupLevelsFilterOptions}
                  testGroupCategoriesFilterOptions={testGroupCategoriesFilterOptions}
                  onSelectCategories={emptyHandler}
                  handleSelectCategoryOption={handleSelectCategoryOption}
                  optionsCategorySelect={[]}
                  testGroupRolesFilterOptions={testGroupRolesFilterOptions}
                  challengeAlkemy={challengeAlkemy}
                  handleSelectRolesOptionsMultiple={handleSelectRolesOptionsMultiple}
                  handleSelectTagsOptions={handleSelectTagsOptions}
                  testGroupTagsFilterOptions={testGroupTagsFilterOptions}
                  handleSelectEndorsementOptions={handleSelectEndorsementOptions}
                  endorsementCreatorsOptions={endorsementCreatorsOptions}
                  handleSelectCompanyUsageOptions={handleSelectCompanyUsageOptions}
                  endorsementCompaniesOptions={endorsementCompaniesOptions}
                  setTestgroupWithThemes={setTestgroupWithThemes}
                  testgroupWithThemes={testgroupWithThemes}
                  isEdit={isEdit}
                  handleModifyData={handleModifyData}
                  handleHideTitle={handleHideTitle}
                  handleIsAutomaticContinue={handleIsAutomaticContinue}
                  handleWithoutTime={handleWithoutTime}
                  setChallengeAlkemy={setChallengeAlkemy}
                  technologies={technologies}
                  handleFilterChange={handleFilterChange}
                  techChallengeAlkemy={techChallengeAlkemy}
                  setTechnologies={setTechnologies}
                  readOnly
                />
              </Panel>
              <Panel
                header={t('CREATE_TESTGROUP_TITLE_COLLAPSE_ASSIGNMENT')}
                key="2"
                className="panel-container bg-gray border-none "
                extra={
                  <FaExclamationCircle
                    className={`mx-2 error-icon-color ${hasAssignment ? '' : 'd-none'}`}
                    title={t('INCOMPLETE')}
                  />
                }
              >
                <TestGroupAssignment
                  handleSetAssignment={handleSetAssignment}
                  step={step}
                  languagesAvailable={[
                    ...new Set([
                      ...(typeof step.subtitle === 'object' &&
                      step.subtitle !== null &&
                      step.subtitle[originalLanguage]
                        ? Object.keys(step.subtitle)
                        : []),
                      languageToTranslate,
                    ]),
                  ]}
                  languageToTranslate={languageToTranslate}
                  languageList={testGroupLanguageList}
                  languageSet={assignmentLanguage}
                  handleChangeLanguage={setAssignmentLanguage}
                />
              </Panel>
              <Panel
                header={t('CREATE_TESTGROUP_TITLE_COLLAPSE_DETAILS')}
                key="3"
                className="panel-container bg-gray border-none "
                extra={
                  <FaExclamationCircle
                    className={`mx-2 error-icon-color ${
                      (testGroupData.summary?.[originalLanguage] ||
                        testGroupData.summary?.length > 0 ||
                        testGroupData.nameTranslated?.[originalLanguage]) &&
                      (!testgroupTranslated?.objetives?.[languageToTranslate] ||
                        !testgroupTranslated?.detail?.[languageToTranslate] ||
                        !testgroupTranslated?.summary?.[languageToTranslate] ||
                        !testgroupTranslated?.nameTranslated?.[languageToTranslate])
                        ? ''
                        : 'd-none'
                    }`}
                    title={t('INCOMPLETE')}
                  />
                }
              >
                <TestGroupLanguage
                  testGroupData={{
                    ...testGroupData,
                    languages: [
                      ...(testGroupData?.languages ?? ['es']),
                      ...(!testGroupData?.languages?.includes(languageToTranslate)
                        ? [languageToTranslate]
                        : []),
                    ],
                    nameTranslated: {
                      ...(testGroupData.nameTranslated ? testGroupData.nameTranslated : {}),
                      ...(testgroupTranslated?.nameTranslated
                        ? testgroupTranslated.nameTranslated
                        : {}),
                    },
                    objetives: {
                      ...(testGroupData.objetives ? testGroupData.objetives : {}),
                      ...(testgroupTranslated?.objetives ? testgroupTranslated.objetives : {}),
                    },
                    detail: {
                      ...(testGroupData.detail ? testGroupData.detail : {}),
                      ...(testgroupTranslated?.detail ? testgroupTranslated.detail : {}),
                    },
                    summary: {
                      ...(testGroupData.summary ? testGroupData.summary : {}),
                      ...(testgroupTranslated?.summary ? testgroupTranslated.summary : {}),
                    },
                  }}
                  languagesList={testGroupLanguageList}
                  handleSelectLanguageOption={emptyHandler}
                  selectedLang={selectedDetailsLang}
                  key={selectedDetailsLang}
                  setSelectedLang={(e) => setSelectedDetailsLang(e)}
                  handleSelectObjetivesOption={(lang, obj) => {
                    handleUpdateTranslatedTestgroup('objetives', {
                      ...(testgroupTranslated?.objetives ?? {}),
                      [lang]: obj,
                    });
                  }}
                  handleModifyLangData={(lang, e) => {
                    handleUpdateTranslatedTestgroup(e.target.name, {
                      ...(testgroupTranslated?.[e.target.name] ?? {}),
                      [lang]: e.target.value,
                    });
                  }}
                  handleSelectTestFormats={emptyHandler}
                  testFormats={testFormats}
                  toggleScoreTags={toggleScoreTags}
                  setToggleScoreTags={emptyHandler}
                  groupSliderInitialData={groupSliderInitialData}
                  handleScoreTags={emptyHandler}
                  readOnly={selectedDetailsLang !== languageToTranslate}
                />
              </Panel>
            </Collapse>
            <div>
              <TestGroupAdvancedSettings
                advancedSetting={
                  testgroupTranslated?.advancedSetting || testGroupData?.advancedSetting
                }
                setAdvancedSetting={handleAdvancedSetting}
                testDifficulty={testDifficulty}
                testQuestions={newScreening?.customTestGroup || []}
                withThemes={testgroupWithThemes}
                testGroupQuestions={testGroupQuestions}
                readOnly
                // Simple mode props from TestGroupDifficultyConfig
                testGroupQuantityQuestions={testGroupQuantityQuestions}
                setTestGroupQuantityQuestions={emptyHandler}
                onBlurInputNumber={emptyHandler}
                handleSelectDifficulty={emptyHandler}
                testGroupDifficult={testGroupDifficult}
                availableThemes={availableThemes}
                handleSelectTheme={emptyHandler}
                testGroupTheme={testGroupTheme}
                testGroupListeningTest={testGroupListeningTest}
                handleAudioDifficulty={emptyHandler}
                handleCreateQuestionsSet={emptyHandler}
                disabledCreateSet={disabledCreateSet}
                setShow={setShow}
                setItemDelete={setItemDelete}
                handleOrderSetQuestions={emptyHandler}
                availableSubskills={availableSubskills}
                handleSelectSubskills={handleSelectSubskills}
                testGroupSubskills={testGroupSubskills}
              />
            </div>
            <div className="my-3">
              <span className="font-weight-600 text-muted text-sm pr-0 text-nowrap">
                {t('TESTGROUP_TEST_LIST_TO_TRANSLATE')}
              </span>
              {customTestgroupInitialData
                .sort((a, b) => a.order - b.order)
                .map((item) => (
                  <TestGroupsItem
                    key={item.deleteId || item.id}
                    test={{
                      ...item,
                      questionDifficulty: t(
                        `CREATE_TEST_GROUP_QUESTION_${
                          testDifficulty.find((d) => d.id === item.difficultyId)?.name ??
                          'NOT_DIFFICULTY'
                        }`
                      ),
                      ...(testgroupWithThemes ? { theme: item?.theme } : { theme: null }),
                    }}
                    handleDelete={emptyHandler}
                    testGroupABM
                    handleSelectTest={emptyHandler}
                    isTranslation
                    translateTest={handleSelectTest}
                    isTranslated={translatedTests[item.id]}
                  />
                ))}
            </div>
            <div className="w-100 d-flex justify-content-end mt-3">
              {savingTestGroupTranslation ? (
                <div className="mt-4">
                  <HorizontalLoader />
                </div>
              ) : (
                <DebouncedButton
                  onClick={handleSaveTestgroupTranslated}
                  disabled={disableTestgroupTranslation || configMissingTests || hasAssignment}
                  className={`rounded-0 mt-4 align-self-end px-3 py-1 text-white text-xs font-weight-bold border-0 outline-none ${
                    disableTestgroupTranslation || configMissingTests || hasAssignment
                      ? 'disabled-button'
                      : 'bg-maya-blue'
                  } ${savingTestGroupTranslation && 'cursor-wait'}`}
                  type="button"
                >
                  {t('CREATE_TEST_GROUP_SAVE_BUTTON')}
                </DebouncedButton>
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default TranslateTestGroup;
